export const valuePresent = (value) => !(value === null || value === undefined || value == '')
